/* Kniha 2: countdown, buy buttons, lightbox, video, family bubbles, sticky bar. */
(function () {
  var root = document.querySelector('[data-k2]');
  if (!root) return;

  function k2Allows(purpose) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var method = purpose === 'marketing' ? 'marketingAllowed' : 'analyticsProcessingAllowed';
      return !!privacy && typeof privacy[method] === 'function' && privacy[method]() === true;
    } catch (error) { return false; }
  }
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
  function k2RecordAdded(result, currency) {
    try {
      var lines = result && (Array.isArray(result.items) ? result.items : [result]);
      if (!lines || !lines.length || !currency) return;
      var value = 0;
      var measured = lines.map(function (line) {
        var quantity = Number(line.quantity), price = Number(line.final_price == null ? line.price : line.final_price) / 100;
        var variant = line.variant_id || line.id;
        if (!variant || !Number.isFinite(quantity) || quantity <= 0 || !Number.isFinite(price) || price < 0) throw new Error('Invalid cart response');
        value += price * quantity;
        return { item_id: (typeof line.sku === 'string' && line.sku.trim()) || String(variant), item_name: line.product_title || line.title || '', item_variant: line.variant_title || '', price: price, quantity: quantity };
      });
      if (k2Allows('analytics')) (window.dataLayer = window.dataLayer || []).push({ event: 'add_to_cart', ecommerce: { currency: currency, value: value, items: measured } });
      if (k2Allows('marketing') && typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { value: value, currency: currency });
    } catch (error) {}
  }

  /* countdown to the end of the pre-order */
  var end = Date.parse(root.getAttribute('data-end') || '');
  [].forEach.call(root.querySelectorAll('[data-count]'), function (box) {
    if (!end) { box.hidden = true; return; }
    var u = {}; ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = box.querySelector('[data-' + k + ']'); });
    var tick = function () {
      var left = Math.max(0, end - Date.now());
      if (!left) { box.classList.add('over'); box.querySelector('.lbl').textContent = box.getAttribute('data-over'); return; }
      var s = Math.floor(left / 1000);
      u.d.textContent = Math.floor(s / 86400); u.h.textContent = ('0' + Math.floor(s % 86400 / 3600)).slice(-2);
      u.m.textContent = ('0' + Math.floor(s % 3600 / 60)).slice(-2); u.s.textContent = ('0' + s % 60).slice(-2);
      setTimeout(tick, 1000);
    };
    tick();
  });

  /* buy: add the tier to the cart and go straight to checkout (the form works without JS too) */
  [].forEach.call(root.querySelectorAll('form[data-k2-buy]'), function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var b = f.querySelector('button'); b.disabled = true; b.setAttribute('aria-busy', 'true');
      var id = f.querySelector('[name=id]').value;
      var items = [{ id: +id, quantity: 1 }];
      var cartPending = false;
      var go = function () {
        if (cartPending) return;
        cartPending = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw r; return r.json().catch(function () { return null; }); })
          .then(function (result) { k2RecordAdded(result, f.getAttribute('data-cur')); location.href = f.getAttribute('data-next') || '/checkout'; })
          .catch(function () { f.submit(); });
      };
      var sum = document.querySelector('[data-k2s]'), art = f.closest('.k2-tier'), tpl = art && art.querySelector('template[data-sum]');
      if (!sum || !tpl) { go(); return; }
      var q = function (s) { return sum.querySelector(s); };
      q('[data-k2s-name]').textContent = art.querySelector('h3').textContent;
      q('[data-k2s-price]').textContent = art.querySelector('.price').textContent;
      q('[data-k2s-list]').innerHTML = tpl.innerHTML;
      var card = tpl.getAttribute('data-card');
      q('.k2s-art').hidden = !card;
      if (card) { q('[data-k2s-img]').src = card; q('[data-k2s-cn]').textContent = tpl.getAttribute('data-card-name'); }
      var bumpId = f.getAttribute('data-bump'), bl = q('[data-k2s-bump]'), cb = q('[data-k2s-bumpcb]');
      if (bl) { bl.hidden = true; cb.checked = false; }
      if (bl && bumpId) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          bl.hidden = c.items.some(function (i) { return String(i.variant_id) === bumpId; });
        }).catch(function () {});
      }
      b.disabled = false; b.removeAttribute('aria-busy');
      sum.hidden = false; q('.k2s-box').scrollTop = 0; q('[data-k2s-go]').focus({ preventScroll: true });
      try { if (k2Allows('analytics')) (window.dataLayer = window.dataLayer || []).push({ event: 'k2_summary_open', tier: f.getAttribute('data-name') }); } catch (x) {}
      q('[data-k2s-go]').onclick = function () {
        this.disabled = true;
        if (cb && cb.checked && bumpId) { items.push({ id: +bumpId, quantity: 1 }); try { if (k2Allows('analytics')) (window.dataLayer = window.dataLayer || []).push({ event: 'k2_bump_yes' }); } catch (x) {} }
        go();
      };
    });
  });

  /* summary: close, and the holographic cards follow the pointer */
  var sm = document.querySelector('[data-k2s]');
  if (sm) {
    [].forEach.call(sm.querySelectorAll('[data-k2s-close]'), function (x) { x.addEventListener('click', function () { sm.hidden = true; }); });
    sm.addEventListener('click', function (e) { if (e.target === sm) sm.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sm.hidden = true; });
  }
  [].forEach.call(document.querySelectorAll('[data-tilt]'), function (el) {
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      el.style.setProperty('--rx', (y * -16).toFixed(1) + 'deg'); el.style.setProperty('--ry', (x * 20).toFixed(1) + 'deg');
      el.style.setProperty('--mx', (50 + x * 100).toFixed(0) + '%'); el.style.setProperty('--my', (50 + y * 100).toFixed(0) + '%');
    });
    el.addEventListener('pointerleave', function () { el.style.removeProperty('--rx'); el.style.removeProperty('--ry'); });
  });

  /* illustrations open large */
  var lb = root.querySelector('.k2-lb');
  [].forEach.call(root.querySelectorAll('[data-big]'), function (el) {
    el.addEventListener('click', function () {
      if (!lb || !lb.showModal) { window.open(el.getAttribute('data-big'), '_blank'); return; }
      var im = lb.querySelector('img'); im.src = el.getAttribute('data-big'); im.alt = el.getAttribute('aria-label') || '';
      lb.showModal();
    });
  });
  if (lb) {
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('button')) lb.close(); });
  }

  /* the making-of video plays only while it is on screen */
  var v = root.querySelector('.k2-video video');
  if (v && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: .35 }).observe(v);
  }

  /* family photos: tap shows the speech bubble, a second tap on another closes the first */
  [].forEach.call(root.querySelectorAll('.k2-ph'), function (ph) {
    ph.addEventListener('click', function () {
      [].forEach.call(root.querySelectorAll('.k2-ph.on'), function (o) { if (o !== ph) o.classList.remove('on'); });
      ph.classList.toggle('on');
    });
  });

  /* sticky buy bar on phones: shown after the hero, hidden while the tiers are on screen */
  var bar = root.querySelector('.k2-bar'), tiers = root.querySelector('#balicky'), hero = root.querySelector('.k2-hero');
  if (bar && tiers && hero && 'IntersectionObserver' in window) {
    var inTiers = false, pastHero = false;
    var upd = function () { bar.classList.toggle('on', pastHero && !inTiers); };
    new IntersectionObserver(function (es) { inTiers = es[0].isIntersecting; upd(); }, { threshold: .05 }).observe(tiers);
    new IntersectionObserver(function (es) { pastHero = !es[0].isIntersecting; upd(); }).observe(hero);
  }
  [].forEach.call(root.querySelectorAll('a[href^="#"]'), function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
      e.preventDefault(); t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* the book on the hero hops when tapped, like the Tamitos */
  var book = root.querySelector('.k2-book');
  if (book) book.addEventListener('click', function () { book.classList.remove('hop'); void book.offsetWidth; book.classList.add('hop'); setTimeout(function () { book.classList.remove('hop'); }, 720); });
})();
